import {createSlice} from '@reduxjs/toolkit';
import {addYears} from "date-fns";
import {toKSTISOString, toKSTISOStringEnd} from "../../components/commonmethod/CommonMethod";

const currentDate = new Date();

const initialSearchState = {
    searchTxt:'',
    startDate:toKSTISOString(addYears(new Date(),-1)),
    endDate:toKSTISOStringEnd(addYears(new Date(),0)),
};
const initialState = {
    keys:'',
    searches: {},
};


const searchSlice = createSlice({
    name: 'search',
    initialState,
    reducers: {
        setKeys(state, action) {
            const {keys} =action.payload;
            state.keys=keys
        },
        setSearch(state, action) {
            const {keys,  ...rest } = action.payload;
            if (!state.searches[keys]) {
                state.searches[keys] = { ...initialSearchState };
            }

            const newState = { ...initialSearchState, ...rest };

            // 기존 상태에 남아있던 불필요한 속성들을 삭제
            // ex) 자산에서 검색조건으로 자산그룹을 검색했다가 자산그룹 검색조건을 제외시
            //      group:{id:??} 가 추가되었다가 조건 제외시 group:{id:null} 이러면 group 의 id가 null 조건을 검색하므로
            //      group 자체를 제거해줘야 함.
            Object.keys(state.searches[state.keys]).forEach(key => {
                if (!(key in newState)) {
                    delete state.searches[state.keys][key];
                }
            });

            // 새로운 상태를 병합.
            state.searches[state.keys] = {
                ...state.searches[state.keys],
                ...newState
            };
        },
        clearSearch(state) {
            if (state.searches[state.keys]) {
                state.searches[state.keys] = {searchTxt:'', startDate: addYears(currentDate, -1), endDate:addYears(currentDate, 0) };
            }
        },
    },
});

export const getSearch = (state) => {
    const keys = state.search.keys;
    return state.search.searches[keys] ?? initialSearchState;
};
export const getKeys = (state) => {
    const keys = state?.search.keys;
    return keys
};

export const { setSearch, clearSearch, initSearch, setKeys } = searchSlice.actions;

export default searchSlice.reducer;
